import React from 'react';
import styled from 'styled-components';

const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const AgenceText = styled.div`
  font-family: var(--font-primary);
  font-size: 1.5rem;
  font-weight: var(--font-weight-light);
  letter-spacing: 3px;
  text-transform: uppercase;
  line-height: 1;
  text-align: center;
  width: 100%;
  
  @media (max-width: 768px) {
    font-size: 1.2rem;
    letter-spacing: 2px;
  }
`;

const FabienneText = styled.div`
  font-family: var(--font-primary);
  font-size: 1rem;
  font-weight: var(--font-weight-light);
  letter-spacing: 3px;
  text-transform: uppercase;
  margin-top: 8px;
  line-height: 1;
  text-align: center;
  width: 100%;
  
  @media (max-width: 768px) {
    font-size: 0.8rem;
    letter-spacing: 2px;
  }
`;

const LogoText: React.FC = () => {
  return (
    <LogoContainer>
      <AgenceText>AGENCE INTERIEURS</AgenceText>
      <FabienneText>FABIENNE BOÉ DE PIREY</FabienneText>
    </LogoContainer>
  );
};

export default LogoText;
